<h1 i18n>Otwarte</h1>

<ng-container *ngFor="let facultyWithRegistrations of openedRegistrationsByFaculties">
  <h2 *ngIf="facultyWithRegistrations[0] as faculty">
    [{{faculty.id}}] {{faculty.description}}
  </h2>

  <ng-container *ngFor="let registration of facultyWithRegistrations[1]">
      <app-registration [registration]="registration"></app-registration>
  </ng-container>
</ng-container>

<hr>

<h1 i18n>Nieaktywne</h1>
<ng-container *ngFor="let facultyWithRegistrations of closedRegistrationsByFaculties">
  <h2 *ngIf="facultyWithRegistrations[0] as faculty">
    [{{faculty.id}}] {{faculty.description}}
  </h2>

  <ng-container *ngFor="let registration of facultyWithRegistrations[1]">
    <app-registration [registration]="registration"></app-registration>
  </ng-container>
</ng-container>
